"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var State = /** @class */ (function () {
    // create everything with initial defaults
    function State() {
        this.convert = false;
        this.exchangeRates = {
            EUR: {},
        };
        this.location = 'DE';
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map